/* generated by pull.js */
const manifest = {
  "editorOnly": true,
  "name": "Clone counter",
  "description": "Adds a counter above the stage in the editor which shows the total amount of clones.",
  "credits": [
    {
      "name": "Jeffalo"
    }
  ],
  "dynamicDisable": true,
  "userscripts": [
    {
      "url": "userscript.js"
    }
  ],
  "userstyles": [
    {
      "url": "style.css"
    }
  ],
  "tags": [
    "recommended"
  ],
  "enabledByDefault": false
};
export default manifest;
